class AnnouncementMarquee extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.announcement-marquee__track');
    this.speed = parseInt(this.dataset.speed) || 30;
    this.direction = this.dataset.direction || 'rtl';
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';
    
    this.init();
  }

  init() {
    // Set CSS variable for animation speed
    this.style.setProperty('--marquee-speed', `${this.speed}s`);
    
    // Setup pause on hover
    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
    }

    // Ensure smooth looping by checking if content is long enough
    this.ensureSeamlessLoop();
  }

  ensureSeamlessLoop() {
    const content = this.querySelector('.announcement-marquee__content');
    const trackWidth = this.offsetWidth;
    const contentWidth = content.offsetWidth;

    // If content is shorter than viewport, duplicate it more times
    if (contentWidth < trackWidth * 2) {
      const duplicatesNeeded = Math.ceil((trackWidth * 2) / contentWidth);
      
      for (let i = 0; i < duplicatesNeeded; i++) {
        const clone = content.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
      }
    }
  }

  pause() {
    this.classList.add('paused');
  }

  play() {
    this.classList.remove('paused');
  }
}

customElements.define('announcement-marquee', AnnouncementMarquee);